import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Btn } from './Btn';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)]">
      <div className="max-w-md w-full rounded-xl border border-[var(--color-line)] bg-[var(--color-surface)] shadow-sm p-8 text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[var(--color-ink)] mb-2">{t('errors.title')}</h1>
          <p className="text-[var(--color-ink-soft)] mb-4">{t('errors.description')}</p>
        </div>

        <div className="space-y-3">
          <Btn kind="primary" className="w-full" onClick={() => window.location.reload()}>
            {t('buttons.retry')}
          </Btn>

          <Btn kind="default" className="w-full" onClick={() => navigate('/formation')}>
            {t('buttons.backToFormations')}
          </Btn>
        </div>
      </div>
    </div>
  );
};
